import { render, staticRenderFns } from "./DhcpLeases.vue?vue&type=template&id=2339b81e&"
import script from "./DhcpLeases.vue?vue&type=script&lang=js&"
export * from "./DhcpLeases.vue?vue&type=script&lang=js&"
import style0 from "./DhcpLeases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports